import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { AuthClassification } from 'src/hooks/auth/auth.interface';
import { ILocationTag } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

import { fetchLocations } from '../locations';
import { mapAllLocationOwnerTags } from './helper';

export const useGetAllLocationOwnerTags = (
  overrideQuerySetting?: UseQueryOptions<ILocationTag[]>,
) =>
  useQuery({
    queryKey: queryKeys.locationOwnerTags.all(),
    queryFn: fetchAllLocationOwnerTags,
    ...overrideQuerySetting,
  });

const fetchAllLocationOwnerTags = async () => {
  const url = `/locationOwnerTags?pageSize=0`;

  const [response, locations] = await Promise.all([
    requestCCApi({ url }),
    queryClient.fetchQuery({
      queryKey: queryKeys.locations.all(),
      queryFn: () => fetchLocations([], AuthClassification.OWNER_OPERATOR),
    }),
  ]);

  if (response.data) {
    return mapAllLocationOwnerTags(response.data, locations);
  }

  return [];
};
